import { useContractSignPolling } from '../../hooks';

export interface ContractSignPollingProps {
  onPoll: () => void;
}

/**
 * Invisible component that polls for contract signing status
 * to be used in Ember components/routes.
 */
export function ContractSignPolling({ onPoll }: ContractSignPollingProps) {
  useContractSignPolling({
    onPoll: () => {
      onPoll();
    },
  });

  return null;
}
